var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"d-flex justify-center",staticStyle:{"height":"100vh"},attrs:{"fill-height":""}},[_vm._v("잠시만 기다려주세요")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }